import React from 'react'
import { useUser } from '../../components/UserContext';
import { Box, Typography } from '@mui/material';

export default function Dashboard() {
  const { currentUser } = useUser();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <Typography variant='h4'>Welcome {currentUser?.name}</Typography>
    </Box>
  )
}
